<template>
    <b-form-row>
        <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

            <b-form @submit.prevent="save">
                <b-card bg-variant="light">
                    <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" "
                        :error="$v.form.descricao" v-model="form.descricao" label="Descrição:*" cols="12" />

                    <LgFinderPageGrupoTipoCaracteristica v-if="telaCarregada"
                        invalidFeedback="Informe um Tipo Característica válido!"
                        id="finderTipoCaracteristicaFormCaracteristica" @close="selecionarGrupo"
                        :prefix="prefix + title + ' > '" v-model="form.tipoCaracteristica">
                    </LgFinderPageGrupoTipoCaracteristica>

                    <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" "
                        :error="$v.form.descricao" v-model="form.mascara" label="Máscara:" cols="12" />


                    <label style="color: black; text-decoration: none; font: 12px Inter sans-serif" class="ml-3"
                        for="checkbox">Obrigatório:</label>


                    <b-form-checkbox id="checkbox" v-model="form.obrigatorio" size="lg" :value="1" :unchecked-value="0"
                        class="ml-3" />


                    <hr>
                    <div class="ml-3">
                        <span>
                            <b>Legenda:</b>
                            <br>
                            # para permitir somente números
                            <br>
                            @ para permitir somente letras
                            <br>
                            * para permitir número ou letra
                            <br>
                            <b>Exemplos:</b>
                            <br>
                            CPF: ###.###.###-##
                            <br>
                            Telefone: (##) ####-####
                        </span>
                    </div>
                    <b-form-row>

                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button id="salvarLocalCadastro" class=" my-2" size="sm" pill variant="success"
                                @click="save">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvarLocalCadastro" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelarLocalCadastro" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelarLocalCadastro" title="Cancelar"></b-tooltip>

                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>

                    </b-form-row>


                </b-card>

            </b-form>
        </b-modal>
    </b-form-row>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { FormResourceMixin } from "@/core/mixins/resource";


export default {
    components: {
        LgFormInput,
        LgFinderPageGrupoTipoCaracteristica: () => import("@/components/Finders/LgFinderPageGrupoTipoCaracteristica.vue"),
    },
    props: {

        id: Number,
        prefix: {
            type: String,
            default: "",
        },
    },
    mixins: [FormResourceMixin],
    validations: {
        form: {
            tipoCaracteristica: { id: { required } },

            descricao: { required },
        },
    },
    data() {
        return {
            showModal: true,
            title: "Cadastro",
            telaCarregada: false,
            form: {
                tipoCaracteristica: {},

                descricao: "",
                situacao: 1,
                mascara: ""
            },
        };
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/caracteristica`);
        if (this.id) {
            const { data } = await this.$service.findById(this.id);
            this.form.id = data.id;
            this.form.prazo = data.prazo;
            this.form.descricao = data.descricao;
            this.form.mascara = data.mascara;
            this.form.obrigatorio = data.obrigatorio;
            this.form.tipoCaracteristica = data.tipoCaracteristica;

        } else {
            this.form.situacao = 1;
        }
        this.telaCarregada = true;

    },

    methods: {

        selecionarGrupo(grupo) {
            this.form.tipoCaracteristica = grupo;
        },
        async save() {
            if (!this.formIsValid) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos de cadastro.",
                });
                return;
            }



            try {
                await this.$saveResource(this.form);
            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }
            this.cancelar();
        },
        cancelar() {
            this.$emit("close");
        },

    },
};
</script>